"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoFormatRelative = void 0;
const getTimeFormatter_js_1 = require("../formatters/getTimeFormatter.js");
const getDateTimeFormatter_js_1 = require("../formatters/getDateTimeFormatter.js");
const getDifferenceInDays_js_1 = require("./getDifferenceInDays.js");
const getDifferenceInHours_js_1 = require("./getDifferenceInHours.js");
const getDifferenceInMinutes_js_1 = require("./getDifferenceInMinutes.js");
const getDifferenceInSeconds_js_1 = require("./getDifferenceInSeconds.js");
const getRelativeOptions = (date) => {
    const now = new Date();
    const timeSegments = [
        {
            diffFn: getDifferenceInSeconds_js_1.getDifferenceInSeconds,
            value: 59,
            unit: 'seconds',
            translationKey: 'secondsRelativeFormat',
        },
        {
            diffFn: getDifferenceInMinutes_js_1.getDifferenceInMinutes,
            value: 59,
            unit: 'minutes',
        },
        {
            diffFn: getDifferenceInHours_js_1.getDifferenceInHours,
            value: 1,
            unit: 'hours',
        },
        {
            diffFn: getDifferenceInDays_js_1.getDifferenceInDays,
            value: 1,
            unit: 'days',
            formatter: getTimeFormatter_js_1.getTimeFormatter,
            translationKey: 'relativeTime',
        },
        {
            diffFn: getDifferenceInDays_js_1.getDifferenceInDays,
            value: Number.POSITIVE_INFINITY,
            formatter: getDateTimeFormatter_js_1.getDateTimeFormatter,
        },
    ];
    const result = timeSegments.find((segment) => {
        const duration = segment.diffFn(now, date);
        return Math.abs(duration) <= segment.value;
    });
    const duration = result.diffFn(now, date);
    return {
        ...result,
        value: Math.round(duration),
    };
};
const autoFormatRelative = (date, intlFormatters, translate) => {
    const { value, unit, formatter, translationKey } = getRelativeOptions(date);
    if (unit == null) {
        return formatter?.(intlFormatters)(date) ?? '';
    }
    const relativePart = intlFormatters.formatRelativeTime(value, unit, {
        numeric: 'auto',
        style: 'long',
    });
    const accuratePart = formatter?.(intlFormatters)(date);
    if (translationKey != null) {
        const translationValues = {
            value,
            isPast: value < 0,
            relativePart: relativePart ?? '',
            accuratePart: accuratePart ?? '',
        };
        return translate(translationKey, translationValues) ?? '';
    }
    return [relativePart, accuratePart].filter(Boolean).join(' ');
};
exports.autoFormatRelative = autoFormatRelative;
//# sourceMappingURL=autoFormatRelative.js.map